import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"

/**
 * @typedef {object} ComponentsAccountsLinkProps
 * @property {unknown} account
 * @property {unknown} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsAccountsLinkState */

/**
 * @extends {ShapeComponent<ComponentsAccountsLinkProps, ComponentsAccountsLinkState>}
 */
class ComponentsAccountsLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    account: instanceOfClassName("Account").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, account, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--accounts--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || account.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || account.name()}
      </span>
    )
  }

  to = () => this.p.adminLayout && Routes.adminAccountPath(this.p.account.id())
}

export default memo(shapeComponent(ComponentsAccountsLink))
